<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>    
</template>

<script>
/**
 * 오류 화면 메인 컴포넌트(Error main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {

}
</script>
